export const SET_PHONE_VERIFIED = 'SET_PHONE_VERIFIED'
export const CHANGE_PHONE_MODEL = 'CHANGE_PHONE_MODEL'
